export default __webpack_public_path__ + "static/media/twitte.53c933f2.svg";